// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

import type { ComponentChildren } from 'preact';
import '../styles/error-screen.css';

interface ErrorScreenProps {
  title: string;
  /** Body copy. String or any preact children for richer cases. */
  body?: ComponentChildren;
  /** Primary action: usually "Back to home" or "Retry". */
  primaryLabel: string;
  onPrimary: () => void;
  /** Optional secondary action. */
  secondaryLabel?: string;
  onSecondary?: () => void;
}

/**
 * F17.1 — shared recovery surface for unrouted URLs (404), caught
 * render errors, and the landing-page-unreachable screen. Single
 * component so the three error surfaces look the same to the user.
 */
export function ErrorScreen({
  title,
  body,
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
}: ErrorScreenProps) {
  return (
    <div class="error-screen">
      <div class="error-screen-card">
        <h1 class="error-screen-title">{title}</h1>
        {body && <div class="error-screen-body">{body}</div>}
        <div class="error-screen-actions">
          <button class="btn btn-primary" onClick={onPrimary}>
            {primaryLabel}
          </button>
          {secondaryLabel && onSecondary && (
            <button class="btn btn-link" onClick={onSecondary}>
              {secondaryLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
